// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes highlight {
    0% {
        background-color: var(--secondary-color-light);
    }
    100% {
        background-color: var(--primary-color-lightest);
    }
}

.post-comment {
    margin: 10px auto;
    font-size: 14px;
    background-color: var(--primary-color-lightest);
    border-radius: 10px;
}
.post-comment.highlight {
    animation-duration: 0.75s;
    animation-direction: forwards;
    animation-timing-function: ease-out;
    animation-name: highlight;
}
.post-comment .post-comment__header {
    display: grid;
    grid-template-columns: auto 48px 24px;
    padding: 10px;
    font-size: 14px;
}
.post-comment .post-comment__controls {
    text-align: right;
    padding-right: 10px;
}
.post-comment .post-comment__content {
    padding: 0 10px 15px 10px;
    white-space: pre-line;
}
.post-comment .post-comment__content .post-comment__moderated {
    font-size: 14px;
    padding: 7px;
    border-radius: 7px;
    background-color: var(--danger-color-lightest);
    border: thin solid var(--danger-color-light);
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/PostComment/PostComment.css"],"names":[],"mappings":"AAAA;IACI;QACI,8CAA8C;IAClD;IACA;QACI,+CAA+C;IACnD;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;IACnC,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,4CAA4C;AAChD","sourcesContent":["@keyframes highlight {\n    0% {\n        background-color: var(--secondary-color-light);\n    }\n    100% {\n        background-color: var(--primary-color-lightest);\n    }\n}\n\n.post-comment {\n    margin: 10px auto;\n    font-size: 14px;\n    background-color: var(--primary-color-lightest);\n    border-radius: 10px;\n}\n.post-comment.highlight {\n    animation-duration: 0.75s;\n    animation-direction: forwards;\n    animation-timing-function: ease-out;\n    animation-name: highlight;\n}\n.post-comment .post-comment__header {\n    display: grid;\n    grid-template-columns: auto 48px 24px;\n    padding: 10px;\n    font-size: 14px;\n}\n.post-comment .post-comment__controls {\n    text-align: right;\n    padding-right: 10px;\n}\n.post-comment .post-comment__content {\n    padding: 0 10px 15px 10px;\n    white-space: pre-line;\n}\n.post-comment .post-comment__content .post-comment__moderated {\n    font-size: 14px;\n    padding: 7px;\n    border-radius: 7px;\n    background-color: var(--danger-color-lightest);\n    border: thin solid var(--danger-color-light);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
